import React, { useEffect, useRef, useState } from 'react';
import {
  bool, elementType, shape, string
} from 'prop-types';
import ReactImageMagnify from 'react-image-magnify';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import { Image as MainAssetImage } from '@thd-olt-component-react/image';
import Helper from '../../../../Helper';
import Threesixty from '../../../Threesixty';
import './main-asset.style.scss';
import '../../../../media-gallery.style.scss';
import '../../../MediaGalleryDesktop/media-gallery-desktop.style.scss';

export const MainAsset = (props) => {
  const {
    fwdOverlayRef, mainAsset, zoomedAsset
  } = props;
  const imageRef = useRef();
  const [imageSize, setImageSize] = useState(1000);

  useEffect(() => {
    if (imageRef?.current) {
      imageRef.current.style.left = '0px';
      imageRef.current.style.right = '0px';
    }
  }, [mainAsset]);

  if (!mainAsset) {
    return null;
  }

  const isAR = Helper.isAR({ media: mainAsset });
  const isImage = Helper.isImage({ media: mainAsset });
  const isImage360 = Helper.isImage360({ media: mainAsset });
  const isVideo = Helper.isVideo({ media: mainAsset });
  const clientSide = typeof window !== 'undefined' && document;
  const zoomedImage = clientSide ? new Image() : null;

  if (zoomedImage) {
    zoomedImage.src = zoomedAsset?.url;
    zoomedImage.onload = () => {
      const imageNaturalSize = zoomedImage.naturalWidth;
      const normalizedWidth = imageNaturalSize < 1000 ? 1000 : imageNaturalSize;
      setImageSize(normalizedWidth);
    };
  }

  const enlargedImageContainerDimensions = {
    width: '100%',
    height: '100%'
  };

  const magnifyLargeImage = {
    src: zoomedAsset?.url,
    width: imageSize,
    height: imageSize
  };

  const imageMagnifyProps = {
    smallImage: {
      isFluidWidth: true,
      src: zoomedAsset?.url
    },
    largeImage: magnifyLargeImage,
    lensStyle: {
      backgroundImage: 'url(https://assets.homedepot-static.com/images/v1/zoom-screen-4X4.svg)',
    },
    enlargedImagePosition: 'over',
    shouldUsePositiveSpaceLens: true,
    enlargedImageContainerDimensions,
    isActivatedOnTouch: true,
  };

  return (
    <div className="main-asset">
      <div className="main-asset__normal-image-wrapper">
        {isImage360 && (
          <Threesixty
            media={mainAsset}
            fwdOverlayRef={fwdOverlayRef}
            fwdImageRef={imageRef}
          />
        )}
        {(isImage || isAR) && (
          <div>
            {isImage && (
              <>
                <div className="main-asset__standard-image">
                  <ReactImageMagnify {...imageMagnifyProps} />
                </div>
                {mainAsset.collection
                && (
                  <div className="shopThisRoomContainer">
                    <a className="shopThisRoomLink" target="_blank" rel="noreferrer" href={mainAsset.collection} onClick={(e) => e && e.stopPropagation()}> Shop This Room </a>
                  </div>
                )}
                {!Helper.isTouchEnabled() && <span className="main-asset__cta">Hover Image to Zoom</span>}
                {Helper.isTouchEnabled() && <span className="main-asset__cta">Tap and Hold to Zoom</span>}
              </>
            )}
            {isAR && (
              <div className="main-asset__ar">
                <MainAssetImage
                  className="main-asset__standard-image main-asset__standard-image--no-cursor"
                  src={mainAsset.mediaStill}
                  alt=""
                  lazy
                />
                <span className="background-circle background-circle--main" />
                <span className="ar-icon ar-icon--main" />
              </div>
            )}
          </div>
        )}
        {isVideo && (
          <VideoPlayer className="main-asset__video-player" videoId={mainAsset.videoId} />
        )}
      </div>
    </div>
  );

};

MainAsset.propTypes = {
  mainAsset: shape({
    id: string,
    url: string,
    mediaType: string
  }),
  zoomedAsset: shape({
    id: string,
    url: string,
    mediaType: string
  }),
  fwdOverlayRef: shape({ current: elementType })
};

MainAsset.defaultProps = {
  mainAsset: {
    id: '',
    url: '',
    mediaType: ''
  },
  zoomedAsset: {
    id: '',
    url: '',
    mediaType: ''
  },
  fwdOverlayRef: null
};

export default MainAsset;
